import {Component, OnInit} from '@angular/core';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';
import {LoaderService, CreditNoteService} from '@app/shared/services';
import {CommonModule,DatePipe} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-new-credit-note',
  templateUrl: './new-credit-note.component.html',
  styleUrls: ['./new-credit-note.component.scss'],
  imports: [
    PageHeaderComponent,
    SelectDropDownModule,
    FormsModule,
    CommonModule,
    NgbHighlight, 
    NgbTypeahead,
  ],
  providers: [DatePipe]
})

export class NewCreditNoteComponent implements OnInit {
    user_rights: any;
    user_data: any;
    customer_options: any;
    invoice_options: any;
    sales_dtls: any;
    searchFailed = false;
    searching = false;
    isEdit: boolean = false;

    public add_crd_note: any =
    {
      customer_id: 0,
      customer_name: "",
      credit_note_no: "",
      cnt_date: new Date(),
      add_crd_note_id: 0,
      edit_status:0
    }

    public crd_note_dtls: any = {
      items: [
        { item: '', rate: 0, qty: 0, total: 0, reason: '', return_rate: '', return_qty: '', return_total: 0, warehouse_dtls_id: 0} 
      ]
    };

    constructor(
      private loaderService: LoaderService,
      private creditNoteService: CreditNoteService,
      protected utils: UtilsInjectable,
      private toastr: ToastrService,
      private route: ActivatedRoute,
      private router: Router,
    ) {}

    ngOnInit() {
      this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
      this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
      this.listCustomer();
      const id = +(this.route.snapshot.paramMap.get('id') || "");
      if (id != null && id != 0) {
        this.isEdit = true;
        this.add_crd_note.add_crd_note_id = id;
        this.getCreditNote(this.add_crd_note.add_crd_note_id);
      } else {
        this.getCreditNoteNo();
      }
    }

    onCustomerChange(selected: any) {
      if (selected) {
        this.add_crd_note.customer_id = selected.value.CUSTOMER_ID;
        this.add_crd_note.customer_name = selected.value.CUSTOMER_NAME;
      } else {
        this.add_crd_note.customer_id = 0;
      }
    }

    clear(){
      this.add_crd_note = {
        customer_id: 0,
        customer_name: "",
        credit_note_no: "",
        cnt_date: new Date(), 
      };

      this.crd_note_dtls = {
        items: [
          { item: '', rate: '', qty: '', total: '', reason: '',return_rate: '', return_qty: '', return_total: '', warehouse_dtls_id: 0 }
        ]
      };
    }

    public listCustomer() {
      this.loaderService.display(true);
      this.creditNoteService.saleCustomerlist().subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.customer_options = result['data'];
        }
        this.loaderService.display(false);
      });
    }

    public getCreditNoteNo() {
      this.loaderService.display(true);
      this.creditNoteService.getCreditNoteNo().subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.add_crd_note.credit_note_no =result['crd_no'];
        }
        this.loaderService.display(false);
      });
    }

    public saveCreditNote() {
      if(!this.add_crd_note.credit_note_no){
        this.toastr.error('Credit note number is required');
        return;
      }else if(!this.add_crd_note.customer_id){
        this.toastr.error('Select customer name');
        return;
      }
      console.log(this.crd_note_dtls.items);
      for (let dtl of this.crd_note_dtls.items) {
        if(!dtl.item || !dtl.item.SALE_ID){
          this.toastr.error('Select invoice/ medicine');
          return;
        }else if(!dtl.return_rate){
          this.toastr.error('Enter return rate');
          return;
        }else if(!dtl.return_qty){
          this.toastr.error('Enter return quantity');
          return;
        }else if(Number(dtl.return_qty) > Number(dtl.qty)){
          this.toastr.error('Return quantity greater than available quantity');
          return;
        }else if(!dtl.reason){
          this.toastr.error('Enter reason');
          return;
        }
      }
      this.loaderService.display(true);
      const data = {
        add_crd_note : this.add_crd_note,
        crd_note_dtls : this.crd_note_dtls
      }
      this.creditNoteService.saveCreditNote(data).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.toastr.success(result['msg']);
          this.clear();
          this.getCreditNoteNo();
          this.router.navigate(['credit-note/credit-note-list']).then();
        }else{
          this.toastr.error(result['msg']);
        }
        this.loaderService.display(false);
      });
    }

    public getToday(): string {
      return new Date().toISOString().split('T')[0]
    }

    public set_item(event: any, i:any): any {
      const selected = event.item;
      this.crd_note_dtls.items[i].item = selected.TRADE_NAME;
      this.crd_note_dtls.items[i].rate = selected.UNIT_PRICE;
      this.crd_note_dtls.items[i].qty = selected.QUANTITY;
      this.crd_note_dtls.items[i].total = selected.PRICE;
      this.crd_note_dtls.items[i].warehouse_dtls_id = selected.WARE_HOUSE_STOCK_DETAILED_ID;
    }

    item_search = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.searching = true),
        switchMap(term => {
          if (!this.add_crd_note.customer_id) {
            this.toastr.error('Select customer name');
            this.searchFailed = true;
            this.searching = false;
            return of([]);
          }

          return this.creditNoteService
            .searchInvoice(term, this.add_crd_note.customer_id)
            .pipe(
              map((response: any) => {
                this.searchFailed = false;
                return response.status === 'Success' ? response.data : [];
              }),
              catchError(() => {
                this.searchFailed = true;
                return of([]);
              })
            );
        }),
        tap(() => this.searching = false)
      );

      formatter = (x: any): string =>
      x ? `${x.TRADE_NAME || ''} - ${x.INVOICE_NUMBER || ''}` : '';

      addRow() {
        this.crd_note_dtls.items.push({ item: '', rate: '', qty: '', total: '', reason: '' });
      }

      removeRow(index: number) {
        this.crd_note_dtls.items.splice(index, 1);
      }

      getCreditNote(id: any) {
        this.creditNoteService.getCreditNote({ crdn_id: id }).subscribe({
          next: (result: any) => {
            if (result["status"] === "Success" && result["data"]?.length) {
              const data = result["data"][0];

              this.add_crd_note = {
                credit_note_no: data.CN_NO,
                cnt_date: data.CN_DATE,
                customer_name: data.CUSTOMER_NAME,
                customer_id: data.CN_SALE_CUSTOMER,
                add_crd_note_id: data.CN_ID,
                edit_status:1
              };

              this.crd_note_dtls.items = result["data"].map((val: any) => ({
                item: {
                  TRADE_NAME: val.TRADE_NAME +" : "+ val.INVOICE_NUMBER,
                  INVOICE_NUMBER: val.INVOICE_NUMBER,
                  SALE_ID: val.CND_INVOICE_ID,
                  MEDICINE_ID: val.MEDICINE_ID
                },
                rate: val.CND_RATE || '',
                qty: val.CND_QTY || '',
                total: val.CND_TOTAL || '',
                return_rate: val.CND_RETURN_RATE || '',
                return_qty: val.CND_RETURN_QTY || '',
                return_total: val.CND_RETURN_TOTAL || '',
                reason: val.CND_REASON || '',
                warehouse_dtls_id : val.WARE_HOUSE_STOCK_DETAILED_ID
              }));
            } 
          },
          error: (err) => {
            console.error('Error fetching credit note:', err);
          }
        });
      }

    calculateRowTotal(row: any) {
      const rate = parseFloat(row.return_rate) || 0;
      const qty = parseFloat(row.return_qty) || 0;

      row.return_total = rate * qty;
    }

    allowFloatNumbers(event: KeyboardEvent) {
      const input = event.target as HTMLInputElement;
      const char = event.key;

      if (!/[\d.]/.test(char)) {
        event.preventDefault();
        return;
      }

      if (char === '.' && input.value.includes('.')) {
        event.preventDefault();
      }
  }


}